import React from 'react'
import { Link } from "react-router-dom";

const Gallery = () => {
    return (
        <>

            <div className="site-breadcrumb" style={{ background: 'url(assets/school/about.webp)' }}>
                <div className="container">
                    <h2 className="breadcrumb-title">Our Gallery</h2>
                    <ul className="breadcrumb-menu">
                        <li><Link to="/">Home</Link></li>
                        <li className="active" style={{ color: "red" }}>Our Gallery</li>
                    </ul>
                </div>
            </div>


            <div className="gallery-area py-120">
                <div className="container">

                    <div className="row">
                        <div className="col-lg-6 mx-auto">
                            <div className="site-heading text-center">
                                <span className="site-title-tagline"><i className="far fa-book-open-reader" /> Gallery</span>
                                <h2 className="site-title">Our <span>Gallery</span></h2>
                            </div>
                        </div>
                    </div>

                    {/* Start 21-10-2026 */}

                    <div className="gallery-area ">
                        <div className="container">
                            <div className="row popup-gallery">
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/121.webp" alt />
                                        </div>
                                        <div className="gallery-content">

                                            <a className="popup-img gallery-link" to="assets/school/Gallery/121.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/122.webp" alt />
                                        </div>
                                        <div className="gallery-content">

                                            <a className="popup-img gallery-link" to="assets/school/Gallery/122.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/123.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/123.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/124.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/124.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/125.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/125.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/126.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/126.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/127.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/127.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/128.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/128.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/129.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/129.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/130.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/130.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/131.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/131.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/132.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/132.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/133.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/133.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/134.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/134.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/135.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/135.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/136.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/136.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/137.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/137.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/138.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/138.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                  
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* end 21-10-2026 */}



                    <div className="gallery-area ">
                        <div className="container">
                            <div className="row popup-gallery">

                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/Result2025-26.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/Result2025-26.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/109.webp" alt />
                                        </div>
                                        <div className="gallery-content">

                                            <a className="popup-img gallery-link" to="assets/school/Gallery/109.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/110.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/110.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/111.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/111.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/112.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/112.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/113.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/113.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/114.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/114.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* new img */}
                    <div className="gallery-area ">
                        <div className="container">
                            <div className="row popup-gallery">
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/30.webp" alt />
                                        </div>
                                        <div className="gallery-content">

                                            <a className="popup-img gallery-link" to="assets/school/30.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/31.webp" alt />
                                        </div>
                                        <div className="gallery-content">

                                            <a className="popup-img gallery-link" to="assets/school/31.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/32.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/32.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/33.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/33.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/34.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/34.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/35.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/35.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/36.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/36.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/37.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/37.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/38.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/38.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/39.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/39.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/40.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/40.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/41.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/41.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/42.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/42.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/43.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/43.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/43.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/43.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/45.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/45.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/46.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/46.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/47.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/47.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="gallery-area ">
                        <div className="container">
                            <div className="row popup-gallery">
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/115.webp" alt />
                                        </div>
                                        <div className="gallery-content">

                                            <a className="popup-img gallery-link" to="assets/school/Gallery/115.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/116.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/116.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/117.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/117.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/118.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/118.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/119.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/119.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/120.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/120.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="gallery-area ">
                        <div className="container">
                            <div className="row popup-gallery">
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/79.webp" alt />
                                        </div>
                                        <div className="gallery-content">

                                            <a className="popup-img gallery-link" to="assets/school/Gallery/79.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/80.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/80.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/81.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/81.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/82.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/82.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/83.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/83.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/84.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/84.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="gallery-area ">
                        <div className="container">
                            <div className="row popup-gallery">
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/85.webp" alt />
                                        </div>
                                        <div className="gallery-content">

                                            <a className="popup-img gallery-link" to="assets/school/Gallery/85.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/86.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/86.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/87.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/87.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/89.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/89.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/90.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/90.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/91.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/91.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="gallery-area ">
                        <div className="container">
                            <div className="row popup-gallery">
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/92.webp" alt />
                                        </div>
                                        <div className="gallery-content">

                                            <a className="popup-img gallery-link" to="assets/school/Gallery/92.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/93.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/93.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/94.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/94.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/95.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/95.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/96.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/96.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/97.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/97.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="gallery-area ">
                        <div className="container">
                            <div className="row popup-gallery">
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/104.webp" alt />
                                        </div>
                                        <div className="gallery-content">

                                            <a className="popup-img gallery-link" to="assets/school/Gallery/104.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/105.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/105.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/106.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/106.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/107.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/107.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/108.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/108.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/91.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/91.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="gallery-area ">
                        <div className="container">
                            <div className="row popup-gallery">
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/98.webp" alt />
                                        </div>
                                        <div className="gallery-content">

                                            <a className="popup-img gallery-link" to="assets/school/Gallery/98.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/99.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/99.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/100.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/100.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/101.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/101.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/102.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/102.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                    <div className="gallery-item">
                                        <div className="gallery-img">
                                            <img src="assets/school/Gallery/103.webp" alt />
                                        </div>
                                        <div className="gallery-content">
                                            <a className="popup-img gallery-link" to="assets/school/Gallery/103.webp"><i className="fal fa-plus" /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div className="row popup-gallery">
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery_1.webp" alt />
                                </div>
                                <div className="gallery-content">

                                    <a className="popup-img gallery-link" to="assets/school/Gallery_1.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery_2.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery_2.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery_3.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery_3.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery_4.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery_4.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery_5.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery_5.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery_6.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery_6.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
            <div className="gallery-area ">
                <div className="container">
                    <div className="row popup-gallery">
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery_7.webp" alt />
                                </div>
                                <div className="gallery-content">

                                    <a className="popup-img gallery-link" to="assets/school/Gallery_7.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery_8.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery_8.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery_9.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery_9.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/002.png" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/002.png"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/003.png" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/003.png"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/1.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/1.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="gallery-area ">
                <div className="container">
                    <div className="row popup-gallery">
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/2.webp" alt />
                                </div>
                                <div className="gallery-content">

                                    <a className="popup-img gallery-link" to="assets/school/Gallery/2.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/3.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/3.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/4.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/4.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/5.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/5.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/6.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/6.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/8.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/8.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gallery-area ">
                <div className="container">
                    <div className="row popup-gallery">
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/9.webp" alt />
                                </div>
                                <div className="gallery-content">

                                    <a className="popup-img gallery-link" to="assets/school/Gallery/9.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/10.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/10.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/11.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/11.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/12.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/12.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/13.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/13.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/14.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/14.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gallery-area ">
                <div className="container">
                    <div className="row popup-gallery">
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/15.webp" alt />
                                </div>
                                <div className="gallery-content">

                                    <a className="popup-img gallery-link" to="assets/school/Gallery/15.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/16.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/16.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/17.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/17.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/18.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/18.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/19.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/19.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/20.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/20.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gallery-area ">
                <div className="container">
                    <div className="row popup-gallery">
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/21.webp" alt />
                                </div>
                                <div className="gallery-content">

                                    <a className="popup-img gallery-link" to="assets/school/Gallery/21.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/22.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/22.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/23.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/23.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/24.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/24.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/25.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/25.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/26.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/26.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gallery-area ">
                <div className="container">
                    <div className="row popup-gallery">
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/27.webp" alt />
                                </div>
                                <div className="gallery-content">

                                    <a className="popup-img gallery-link" to="assets/school/Gallery/27.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/28.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/28.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/29.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/29.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/30.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/30.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/31.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/31.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/32.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/32.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gallery-area ">
                <div className="container">
                    <div className="row popup-gallery">
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/33.webp" alt />
                                </div>
                                <div className="gallery-content">

                                    <a className="popup-img gallery-link" to="assets/school/Gallery/33.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/34.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/34.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/35.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/35.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/36.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/36.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/37.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/37.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/38.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/38.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gallery-area ">
                <div className="container">
                    <div className="row popup-gallery">
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/39.webp" alt />
                                </div>
                                <div className="gallery-content">

                                    <a className="popup-img gallery-link" to="assets/school/Gallery/39.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/40.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/40.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/45.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/45.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/46.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/46.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/47.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/47.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/48.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/48.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gallery-area ">
                <div className="container">
                    <div className="row popup-gallery">
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/49.webp" alt />
                                </div>
                                <div className="gallery-content">

                                    <a className="popup-img gallery-link" to="assets/school/Gallery/49.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/50.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/50.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/51.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/51.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/52.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/52.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/53.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/53.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/54.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/54.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gallery-area ">
                <div className="container">
                    <div className="row popup-gallery">
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/55.webp" alt />
                                </div>
                                <div className="gallery-content">

                                    <a className="popup-img gallery-link" to="assets/school/Gallery/55.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/56.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/56.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/57.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/57.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/58.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/58.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/59.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/59.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/60.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/60.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gallery-area ">
                <div className="container">
                    <div className="row popup-gallery">
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/61.webp" alt />
                                </div>
                                <div className="gallery-content">

                                    <a className="popup-img gallery-link" to="assets/school/Gallery/61.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/62.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/62.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/63.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/63.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/64.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/64.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/65.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/65.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/66.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/66.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gallery-area ">
                <div className="container">
                    <div className="row popup-gallery">
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/67.webp" alt />
                                </div>
                                <div className="gallery-content">

                                    <a className="popup-img gallery-link" to="assets/school/Gallery/67.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/68.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/68.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/69.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/69.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/70.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/70.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/71.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/71.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/72.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/72.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gallery-area ">
                <div className="container">
                    <div className="row popup-gallery">
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/73.webp" alt />
                                </div>
                                <div className="gallery-content">

                                    <a className="popup-img gallery-link" to="assets/school/Gallery/73.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/74.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/74.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/75.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/75.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/76.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/76.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/77.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/77.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="gallery-img">
                                    <img src="assets/school/Gallery/78.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/school/Gallery/78.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <br /><br /><br />





        </>
    )
}

export default Gallery